module.exports = __webpack_public_path__ + "media/Tiwa-Savage-–-Owo-Mi-Da.488e76ef.mp3";